// STEP 1 - Include Dependencies
// Include react
import React from 'react'

// Include the react-fusioncharts component
import ReactFC from 'react-fusioncharts'

// Include the fusioncharts library
import FusionCharts from 'fusioncharts'

// Include the chart type
import Chart from 'fusioncharts/fusioncharts.charts'

// Include the theme as fusion
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.gammel'

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Chart, FusionTheme)

// STEP 2 - Chart Data

// STEP 3 - Creating the JSON object to store the chart configurations

const ChartComponent = ({ data }) => {
  const chartConfigs = {
    type: 'doughnut2d', // The chart type
    width: '100%', // Width of the chart
    height: '400', // Height of the chart
    dataFormat: 'json', // Data type
    dataSource: {
      // Chart Configuration
      chart: {
        caption: 'Star Per Language',
        decimals: 0, // decimals from 0 to 1
        doughnutRadius: '45%',
        showPercentValues: 0,
        theme: 'gammel',
        // paletteColors: ['#f0db4f', '#2f91d3', '#863da5'], // build up the pallets colors that have enough colors to display the data, otherwise color will be reuse
      },
      // Chart Data
      data, // es6 syntax
      // data: data, es5 syntax
    },
  }
  return <ReactFC {...chartConfigs} />
}

export default ChartComponent
